// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("config/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("config/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("config/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("config/fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 400;
  font-style: normal;
}

.slick-prev:before {
  color: #e3e3e3 !important;
}
.slick-next:before {
  color: #e3e3e3 !important;
}
.slick-dots li button:before {
  color: #e3e3e3 !important;
}

.rotate{
  transform: rotate(90deg);
}
@keyframes floating-heart {
  0% {
    opacity: 0;
    bottom: 0%;
    /* right: 0%; */
    transform: rotate(5deg);
  }
  10% {
    opacity: 1;
    bottom: 20%;
    /* right: 70%; */
    transform: rotate(-5deg);
  }
  20% {
    bottom: 40%;
    /* right: 20%; */
    transform: rotate(5deg);
  }
  30% {
    bottom: 60%;
    /* right: 60%; */
    transform: rotate(-5deg);
  }
  40% {
    opacity: 1;
    bottom: 80%;
    /* right: 30%; */
    transform: rotate(5deg);
  }
  48% {
    opacity: 0;
    bottom: 100%;
    /* right: 50%; */
    transform: rotate(-5deg);
  }
  100% {
    opacity: 0;
    bottom: 100%;
    /* right: 80%; */
    display: none;
    transform: rotate(5deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,UAAU;IACV,UAAU;IACV,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":["@font-face {\n  font-family: \"Poppins\";\n  src: url(config/fonts/Poppins-Bold.ttf);\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(config/fonts/Poppins-SemiBold.ttf);\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(config/fonts/Poppins-Medium.ttf);\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Poppins\";\n  src: url(config/fonts/Poppins-Regular.ttf);\n  font-weight: 400;\n  font-style: normal;\n}\n\n.slick-prev:before {\n  color: #e3e3e3 !important;\n}\n.slick-next:before {\n  color: #e3e3e3 !important;\n}\n.slick-dots li button:before {\n  color: #e3e3e3 !important;\n}\n\n.rotate{\n  transform: rotate(90deg);\n}\n@keyframes floating-heart {\n  0% {\n    opacity: 0;\n    bottom: 0%;\n    /* right: 0%; */\n    transform: rotate(5deg);\n  }\n  10% {\n    opacity: 1;\n    bottom: 20%;\n    /* right: 70%; */\n    transform: rotate(-5deg);\n  }\n  20% {\n    bottom: 40%;\n    /* right: 20%; */\n    transform: rotate(5deg);\n  }\n  30% {\n    bottom: 60%;\n    /* right: 60%; */\n    transform: rotate(-5deg);\n  }\n  40% {\n    opacity: 1;\n    bottom: 80%;\n    /* right: 30%; */\n    transform: rotate(5deg);\n  }\n  48% {\n    opacity: 0;\n    bottom: 100%;\n    /* right: 50%; */\n    transform: rotate(-5deg);\n  }\n  100% {\n    opacity: 0;\n    bottom: 100%;\n    /* right: 80%; */\n    display: none;\n    transform: rotate(5deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
